<template>
  <base-table-wrapper>
    <template #top-buttons>
      <router-link :to="{ name: 'EXSBWarehouseCreate' }" class="mb-1 btn btn-sm btn-primary float-right">{{ $t('buttons.create') }}</router-link>
    </template>
    <template #body>
      <Loader v-if="isLoading"></Loader>
      <span v-else-if="!isLoading && items.length < 1">{{$t('views.exsbwarehouses.list.noWarehouses')}}</span>
      <table v-else class="table table-sm table-responsive-md table-striped table-hover">
        <thead>
        <tr>
          <th>{{$t('views.exsbwarehouses.list.type')}}</th>
          <th>{{$t('views.exsbwarehouses.list.name')}}</th>
          <th>{{$t('views.exsbwarehouses.list.idCustom')}}</th>
          <th colspan="2" />
        </tr>
        </thead>
        <tbody>
        <tr v-for="item in items" :key="item['@id']">
          <td>
            {{ item['type'] ? item['type'].name : '' }}
          </td>
          <td>
            {{ item['name'] }}
          </td>
          <td>
            {{ item['idCustom'] }}
          </td>
          <td>
            <div class="btn-group float-right">
              <router-link v-if="ableToShowWarehouse"
                           tag="button"
                           aria-hidden="true"
                           :to="{name: 'EXSBWarehouseShow', params: { id: item['@id'] }}"
                           class="btn btn-link fa fa-search fa-lg" v-b-tooltip.hover :title="$t('buttons.edit')">
              </router-link>
              <router-link v-if="ableToUpdateWarehouse"
                           tag="button"
                           aria-hidden="true"
                           :to="{name: 'EXSBWarehouseUpdate', params: { id: item['@id'] }}"
                           class="btn btn-link fa fa-edit fa-lg" v-b-tooltip.hover :title="$t('buttons.goto')">
              </router-link>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
      <div v-if="view">
        <pagination
          :view="view"
          @getPage="getPage($event)"
        ></pagination>
      </div>
    </template>
  </base-table-wrapper>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { checkPagePermission, checkPermission } from '@/utils/checkRoles.js'
import Loader from '../../../Layout/Loader'
import Pagination from '../../../Layout/Pagination'
import BaseTableWrapper from '@/components/BaseComponents/BaseTableWrapper'

export default {
  components: {
    Loader,
    Pagination,
    BaseTableWrapper
  },

  computed: {
    ...mapGetters({
      deletedItem: 'exsbwarehouse/del/deleted',
      error: 'exsbwarehouse/list/error',
      items: 'exsbwarehouse/list/items',
      isLoading: 'exsbwarehouse/list/isLoading',
      view: 'exsbwarehouse/list/view'
    }),
    ableToShowWarehouse () {
      return checkPermission('warehouses', 'EXSBWarehouseShow')
    },
    ableToUpdateWarehouse () {
      return checkPermission('warehouses', 'EXSBWarehouseUpdate')
    }
  },
  beforeCreate () {
    checkPagePermission('warehouses', 'EXSBWarehouseList')
  },

  created () {
    this.getPage()
    this.channelBusinessWarehouses = this.$store.state.Pusher.subscribe('e_x_s_b_warehouses')
    this.channelBusinessWarehouses.bind('e_x_s_b_warehouses', data => {
      this.getPage()
    })
  },

  destroyed () {
    this.$store.state.Pusher.unsubscribe('e_x_s_b_warehouses')
  },

  methods: mapActions({
    getPage: 'exsbwarehouse/list/default'
  })
}
</script>
